import { render, staticRenderFns } from "./leftSidebar.vue?vue&type=template&id=651d7a5a&"
import script from "./leftSidebar.vue?vue&type=script&lang=js&"
export * from "./leftSidebar.vue?vue&type=script&lang=js&"
import style0 from "./leftSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports